"use client";

import BottomToast from "@/components/common/BottomToast";

type LoginRequiredToastProps = {
  isVisible: boolean;
  onClose: () => void;
  message?: string;
  autoHideMs?: number;
};

export default function LoginRequiredToast({
  isVisible,
  onClose,
  message = "전체 서비스를 이용하시려면 로그인 해주세요.",
  autoHideMs = 3500,
}: LoginRequiredToastProps) {
  return (
    <BottomToast
      isVisible={isVisible}
      message={message}
      onClose={onClose}
      variant="error"
      autoHideMs={autoHideMs}
    />
  );
}


